import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { SubscriptionProvider } from "@/context/SubscriptionContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { SubscriptionGate } from "@/components/SubscriptionGate";
import { AppLayout } from "@/components/AppLayout";

import Login from "@/pages/Login";
import Register from "@/pages/Register";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import PublicQuote from "@/pages/PublicQuote";
import Dashboard from "@/pages/Dashboard";
import Clients from "@/pages/Clients";
import Products from "@/pages/Products";
import Quotes from "@/pages/Quotes";
import Invoices from "@/pages/Invoices";
import InvoiceDetail from "@/pages/InvoiceDetail";
import Payments from "@/pages/Payments";
import Team from "@/pages/Team";
import Works from "@/pages/Works";
import WorkDetail from "@/pages/WorkDetail";
import Platform from "@/pages/Platform";
import PlatformSettings from "@/pages/PlatformSettings";
import PlatformPlans from "@/pages/PlatformPlans";
import AcceptInvite from "@/pages/AcceptInvite";
import MyPlan from "@/pages/MyPlan";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentResult from "@/pages/PaymentResult";
import RefundPolicy from "@/pages/RefundPolicy";
import Terms from "@/pages/Terms";
import Privacy from "@/pages/Privacy";
import PlatformCompany from "@/pages/PlatformCompany";
import SiteSettings from "@/pages/SiteSettings";
import SiteMenu from "@/pages/SiteMenu";
import Reservations from "@/pages/Reservations";
import PublicSite from "@/pages/PublicSite";
import DemoSite from "@/pages/DemoSite";
import Prospecting from "@/pages/Prospecting";
import QuoteRequests from "@/pages/QuoteRequests";
import Cash from "@/pages/Cash";
import Expenses from "@/pages/Expenses";
import Stock from "@/pages/Stock";
import Reports from "@/pages/Reports";
import Marketing from "@/pages/Marketing";
import MarketingBrand from "@/pages/MarketingBrand";
import MarketingHistory from "@/pages/MarketingHistory";
import MarketingSettings from "@/pages/MarketingSettings";

function Protected({ children }) {
  return (
    <ProtectedRoute>
      <SubscriptionGate>
        <AppLayout>{children}</AppLayout>
      </SubscriptionGate>
    </ProtectedRoute>
  );
}

const PROTECTED = [
  ["/", Dashboard], ["/clientes", Clients], ["/produtos", Products], ["/orcamentos", Quotes],
  ["/vendas", Invoices], ["/vendas/:id", InvoiceDetail], ["/pagamentos", Payments], ["/caixa", Cash],
  ["/despesas", Expenses], ["/stock", Stock], ["/relatorios", Reports], ["/obras", Works], ["/obras/:id", WorkDetail],
  ["/equipa", Team], ["/plataforma", Platform], ["/plataforma/prospeccao", Prospecting], ["/plataforma/pagamentos", PlatformSettings], ["/plataforma/planos", PlatformPlans], ["/plataforma/empresa", PlatformCompany],
  ["/meu-site", SiteSettings], ["/carta", SiteMenu], ["/reservas", Reservations], ["/pedidos-orcamento", QuoteRequests],
  ["/marketing", Marketing], ["/marketing/marca", MarketingBrand],
  ["/marketing/historico", MarketingHistory], ["/marketing/configuracoes", MarketingSettings],
];

function PrivateApp() {
  return (
    <AuthProvider>
      <SubscriptionProvider>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/q/:token" element={<PublicQuote />} />
          <Route path="/aceitar-convite" element={<AcceptInvite />} />
          {PROTECTED.map(([path, Page]) => (
            <Route key={path} path={path} element={<Protected><Page /></Protected>} />
          ))}
          <Route path="/o-meu-plano" element={<ProtectedRoute><AppLayout><MyPlan /></AppLayout></ProtectedRoute>} />
          <Route path="/payment/success" element={<ProtectedRoute><PaymentSuccess /></ProtectedRoute>} />
          <Route path="/pagamento/resultado" element={<ProtectedRoute><PaymentResult /></ProtectedRoute>} />
          <Route path="/subscricao" element={<Navigate to="/o-meu-plano" replace />} />
          <Route path="/faturas" element={<Navigate to="/vendas" replace />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </SubscriptionProvider>
    </AuthProvider>
  );
}

function App() {
  return (
    <div className="App">
      <Toaster position="top-right" richColors />
      <BrowserRouter>
        <Routes>
          <Route path="/s/:slug" element={<PublicSite />} />
          <Route path="/demo/:slug" element={<DemoSite />} />
          <Route path="/inicio" element={<Navigate to="/" replace />} />
          <Route path="/politica-de-devolucao" element={<RefundPolicy />} />
          <Route path="/termos" element={<Terms />} />
          <Route path="/privacidade" element={<Privacy />} />
          <Route path="*" element={<PrivateApp />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
